import React, { FunctionComponent } from "react";
import { ProofOperationDialogProps } from "./ProofOperationDialog";
import ProofOperationWrapper from "./ProofOperationWrapper";

export interface StartProofProps extends Omit<ProofOperationDialogProps, "isEditOperation"> {
}

const StartProof: FunctionComponent<StartProofProps> = (props) => {
	return (<ProofOperationWrapper {...props} />);
};

export default StartProof;